<template>
    <div class="ds-employees-content ds-employees-page-layout">
        <EmployeesToolbar @search-input="onSearch" @create="emit('create')" :archive  />
        <div class="ds-table-header flex pt-6 pb-3">
            <div class="w-9 flex items-center justify-center"><checkbox></checkbox></div>
            <div class="w-20"></div>
            <div class="flex-1 max-w-screen-sm flex">ФИО</div>
            <div class="flex-1 max-w-md flex relative">Должность
                <icon @click="positionsFilter = !positionsFilter" class="relative top-1 ml-1 cursor-pointer"><IconSort width="16" height="16"  /></icon>
                <EmployeeFilter v-if="positionsFilter" @check="getEmployees" v-click-outside="closeFilterPositions" v-model="filterPositionsItems" @reset="onFilterPositionReset" class="absolute top-5" />
            </div>
            <div class="w-64 flex relative">Подразделение<icon @click="departmentsFilter = !departmentsFilter" class="relative top-1 ml-1"><IconSort width="16" height="16" /></icon>
                <EmployeeFilter v-if="departmentsFilter" :search="true" @onsearch="onDepSearch" v-click-outside="closeFilterDepartments" v-model="filterDepartmentsItems" @reset="onFilterDepartmentReset" @check="getEmployees" class="absolute top-5" />
            </div>
            <div class="w-24" v-if="archive">Уволен</div>
            <div class="w-16" v-else>Рейтинг</div>
        </div>
        <div class="wrapper overflow-y-auto text-sm">
            <div v-for="employee in employees" class="ds-table-row flex items-center" :key="employee.id">
                <EmployeesListItem :employee @user="emit('user-click', { id: employee.id, archive})" :archive  />
            </div>
        </div>
        <div class="ds-employees-pager-row" v-show="showAll || employmentStore.usersCount > emplPerPage">
            <Pager v-model:page="pageNum" :items="employmentStore.usersCount" @page="onPage" />
        </div>
    </div>
</template>

<script setup lang="ts">
interface Props {
    archive: boolean
}
import { useScheduleStore } from '@/stores/scheduleStore'
import { useDepartmentStore } from '@/stores/departmentStore'
import { useEmploymentStore } from '@/stores/employmentStore'
import { ref, onMounted, computed } from 'vue'
import EmployeesListItem from './EmployeesListItem.vue'
import IconSort from '@/ui/icons/IconSort.vue'
import Pager from '@/components/employees/Pager.vue'
import EmployeesToolbar from '@/components/employees/EmployeesToolbar.vue'
import EmployeeFilter from './EmployeeFilter.vue'

const { archive } = defineProps<Props>()

const departmentStore = useDepartmentStore()
const scheduleStore = useScheduleStore()
const employmentStore = useEmploymentStore()
const employees = computed(() => employmentStore.users)
const emit = defineEmits(['user-click', 'check-click', 'create'])
const timeout = ref()

const emplPerPage = ref(15)
const pageNum = ref(1)
const showAll = ref(false)

const positionsFilter = ref(false)
const departmentsFilter = ref(false)
const searchText = ref('')
const filterPositionsItems = ref<any[]>([])
const filterDepartmentsItems = ref<any[]>([])
const filterDepartmentsDefault = ref<any[]>([])

const onPage = async (data:any) => {
    const { page, itemsPerPage } = data
    pageNum.value = page
    showAll.value = itemsPerPage.id === 'all'
    if (!showAll.value) emplPerPage.value = itemsPerPage.id
    await getEmployees()
}

const onSearch = async (text: string) => {
    clearTimeout(timeout.value)
    timeout.value = setTimeout(() => {
        searchText.value = text
        pageNum.value = 1
        getEmployees()
    }, 1000)
}

const onDepSearch = (text: string) => {
    filterDepartmentsItems.value = filterDepartmentsDefault.value.filter(item => item.name.toLowerCase().includes(text.toLowerCase()))
}


const closeFilterPositions = () => {
    positionsFilter.value = false
}

const closeFilterDepartments = () => {
    departmentsFilter.value = false
}

const onFilterPositionReset = () => {
    filterPositionsItems.value = scheduleStore.positions.map(item => { return { check: false, ...item } })
}

const onFilterDepartmentReset = () => {
    filterDepartmentsItems.value = departmentStore.myDepartments.map(item => { return { check: false, ...item } })
    filterDepartmentsDefault.value = filterDepartmentsItems.value
}

async function getEmployees() {
    const data:any = {
        page_size: showAll.value ? employmentStore.usersCount : emplPerPage.value,
        page: pageNum.value
    }
    if(filterDepartmentsItems.value.filter(item => item.check).length) data.department_ids = filterDepartmentsItems.value.filter(item => item.check).map(item => item.id).join(',')
    if(filterPositionsItems.value.filter(item => item.check).length) data.position_ids = filterPositionsItems.value.filter(item => item.check).map(item => item.id).join(',')
    if(searchText.value) data.search = searchText.value

    const requestedSize = data.page_size
    if(archive) await employmentStore.fetchUsersFired(data)
    else await employmentStore.fetchUsers(data)

    if(showAll.value && employmentStore.usersCount > requestedSize) {
        data.page_size = employmentStore.usersCount
        if(archive) await employmentStore.fetchUsersFired(data)
        else await employmentStore.fetchUsers(data)
    }
}

onMounted(async () => {
    await getEmployees()
    onFilterDepartmentReset()
    onFilterPositionReset()
})
</script>

<style scoped>
.wrapper {
    height: auto;
}
</style>
